<div class="p-grid">
  <div class="p-col-8 multiselect">
    <h6>Zip Code(s)</h6>
    <p-multiselect autofocusFilter placeholder=" " 
      fluid
      [options]="zipCodeOptions"
      [panelStyle]="{minWidth:'12em'}"
      name="dayZipCodeAssignments"
      [(ngModel)]="timeSlot.regionalManagerTimeSlotZipCodes"
      >
      <ng-template let-value pTemplate="selectedItems">
        @for (val of value; track val) {
          <div class="ui-multiselected-item-token ui-corner-all">
            <span>{{val.zipCode.code}} - {{val.zipCode.city}}</span>
          </div>
        }
        @if (!value || value.length === 0) {
          <span class="ui-multiselected-empty-token ui-corner-all">Choose</span>
        }
      </ng-template>
      <ng-template let-item pTemplate="item">
        {{item.label}}
      </ng-template>
    </p-multiselect >
  </div>
  <div class="p-col-2">
    <h6>Time Slot</h6>
    <div class="p-grid">
      <div class="p-col">
        <p-datepicker
          [(ngModel)]="timeSlot.timeBegin"
          [timeOnly]="true"
          hourFormat="12"
          [style]="{'width':'100%'}"
          [inputStyle]="{'width':'100%'}">
        </p-datepicker>
      </div>
      <div class="p-col-1 center">
        to
      </div>
      <div class="p-col">
        <p-datepicker
          [(ngModel)]="timeSlot.timeEnd"
          [timeOnly]="true"
          hourFormat="12"
          [style]="{'width':'100%'}"
        [inputStyle]="{'width':'100%'}"></p-datepicker>
      </div>
    </div>
  </div>
  <div class="p-col-2">
    <h6>Action</h6>
    <p-button severity="success" pTooltip="Save" label="Save" (click)="save()" [disabled]="saving"></p-button>
    <p-button severity="danger" pTooltip="Delete" icon="pi pi-trash" (click)="delete()"></p-button>
  </div>
</div>
